/*
 * ECCN Matrix Block
 * https://wiki.one.int.sap/wiki/pages/viewpage.action?pageId=5095933887
 */

import '@sapudex/web-components/dist/Table.js';
import '@sapudex/web-components/dist/TableHeaderRow.js';
import '@sapudex/web-components/dist/TableHeaderCell.js';
import '@sapudex/web-components/dist/TableRow.js';
import '@sapudex/web-components/dist/TableCell.js';
import '@sapudex/web-components/dist/Pagination.js';
import '@sapudex/web-components/dist/Link.js';
import '@sapudex/web-components/dist/Accordion.js';
import '@sapudex/web-components/dist/AccordionItem.js';

import { div } from '../../scripts/dom-builder.js';
import { isAuthorEnv } from '../../scripts/utils/env-utils.js';
import { waitForIsFromSAP } from '../../scripts/utils/sap-utils.js';
import { ECCN_MATRIX_MAX_COLUMNS } from './finder-eccn-matrix.constants.js';
import handleSearchEvent from './handlers/search-event.js';
import { buildTableAndPagination } from './utils/build-table-and-pagination.js';
import { downloadExcel } from './utils/download.js';
import fetchData from './utils/fetch-data.js';
import { getAccordion } from './utils/get-accordion.js';
import { getDownloadButton } from './utils/get-download-button.js';
import { rerenderFirstColumnForSAP } from './utils/render-first-column-sap.js';

export default async function decorate(block) {
  if (isAuthorEnv()) {
    import('./authoring/expand-finder-matrix.js').then(
      ({ default: expandFinderMatrix }) => expandFinderMatrix(block),
    );
  }

  const tableWrapper = div({ class: 'table-wrapper' });

  const downloadButton = await getDownloadButton();

  const contentBlock = div(
    { class: 'finder-eccn-matrix' },
    div(
      { class: 'eccn-content' },
      getAccordion(block),
      div({ class: 'finder-eccn-matrix__download-button' }, downloadButton),
    ),
    tableWrapper,
  );

  block.replaceChildren(contentBlock);

  let originalData = [];
  try {
    originalData = await fetchData();
  } catch (error) {
    console.info('Failed to fetch ECCN matrix data:', error);
  }

  const headers = originalData.length
    ? Object.keys(originalData[0]).slice(0, ECCN_MATRIX_MAX_COLUMNS)
    : [];

  const currentData = [...originalData];
  const currentDataRef = { current: currentData };

  downloadButton.disabled = !currentData.length;

  downloadButton.addEventListener('click', () => {
    if (currentDataRef.current?.length > 0) {
      downloadExcel(currentDataRef.current);
    }
  });

  buildTableAndPagination(tableWrapper, headers, currentData);

  waitForIsFromSAP()
    .then(() => rerenderFirstColumnForSAP(tableWrapper))
    .catch(() => console.info('SAP check timed out'));

  document.addEventListener('searchEvent', (e) => {
    handleSearchEvent({
      event: e,
      originalData,
      headers,
      downloadButton,
      tableWrapper,
      buildTableAndPagination,
      currentDataRef,
    });
  });
}
